import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function GreaseTrapIcon(props) {
	return (
		<IconBase type="grease-trap" {...props}>
			<path d="M4 6H20V10.5H21V11H23V13H21V13.5H20V18H4V13.5H3V13H1V11H3V10.5H4V6ZM5 7V13.5H5.39155C5.46251 13.5 5.53214 13.4807 5.593 13.4442L7.39675 12.362C7.75863 12.1448 8.21786 12.1782 8.54448 12.4455L9.30491 13.0677C9.62359 13.3284 10.0695 13.3671 10.4284 13.1653L11.8743 12.3519C12.2483 12.1416 12.7147 12.1932 13.0336 12.4802L13.6473 13.0326C13.9593 13.3133 14.4133 13.3694 14.7842 13.1731L16.3473 12.3456C16.7352 12.1402 17.2118 12.2118 17.5223 12.5223L18.3964 13.3964C18.4627 13.4628 18.5527 13.5 18.6464 13.5H19V7H5Z" />
		</IconBase>
	);
}
GreaseTrapIcon.propTypes = iconPropTypes;
